module.exports = {
	"_args": [
		[
			{
				"raw": "hawk@~3.1.3",
				"scope": null,
				"escapedName": "hawk",
				"name": "hawk",
				"rawSpec": "~3.1.3",
				"spec": ">=3.1.3 <3.2.0",
				"type": "range"
			},
			"C:\\Projects\\told-npm\\azure-functions-server\\node_modules\\request"
		]
	],
	"_from": "hawk@>=3.1.3 <3.2.0",
	"_id": "hawk@3.1.3",
	"_inCache": true,
	"_installable": true,
	"_location": "/hawk",
	"_nodeVersion": "5.4.1",
	"_npmUser": {
		"name": "hueniverse",
		"email": "eran@hammer.io"
	},
	"_npmVersion": "3.3.12",
	"_phantomChildren": {},
	"_requested": {
		"raw": "hawk@~3.1.3",
		"scope": null,
		"escapedName": "hawk",
		"name": "hawk",
		"rawSpec": "~3.1.3",
		"spec": ">=3.1.3 <3.2.0",
		"type": "range"
	},
	"_requiredBy": [
		"/request"
	],
	"_resolved": "https://registry.npmjs.org/hawk/-/hawk-3.1.3.tgz",
	"_shasum": "078444bd7c1640b0fe540d2c9b73d59678e8e1c4",
	"_shrinkwrap": null,
	"_spec": "hawk@~3.1.3",
	"_where": "C:\\Projects\\told-npm\\azure-functions-server\\node_modules\\request",
	"author": {
		"name": "Eran Hammer",
		"email": "eran@hammer.io",
		"url": "http://hueniverse.com"
	},
	"browser": "./lib/browser.js",
	"bugs": {
		"url": "https://github.com/hueniverse/hawk/issues"
	},
	"contributors": [],
	"dependencies": {
		"boom": "2.x.x",
		"cryptiles": "2.x.x",
		"hoek": "2.x.x",
		"sntp": "1.x.x"
	},
	"description": "HTTP Hawk Authentication Scheme",
	"devDependencies": {
		"code": "1.x.x",
		"lab": "5.x.x"
	},
	"directories": {},
	"dist": {
		"shasum": "078444bd7c1640b0fe540d2c9b73d59678e8e1c4",
		"tarball": "https://registry.npmjs.org/hawk/-/hawk-3.1.3.tgz"
	},
	"engines": {
		"node": ">=0.10.32"
	},
	"gitHead": "2f0b93b34ed9b0ebc865838ef70c6a4035591430",
	"homepage": "https://github.com/hueniverse/hawk#readme",
	"keywords": [
		"http",
		"authentication",
		"scheme",
		"hawk"
	],
	"license": "BSD-3-Clause",
	"main": "lib/index.js",
	"maintainers": [
		{
			"name": "hueniverse",
			"email": "eran@hueniverse.com"
		}
	],
	"name": "hawk",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git://github.com/hueniverse/hawk.git"
	},
	"scripts": {
		"test": "lab -a code -t 100 -L",
		"test-cov-html": "lab -a code -r html -o coverage.html"
	},
	"version": "3.1.3"
};


//////////////////
// WEBPACK FOOTER
// ./~/hawk/package.json
// module id = 153
// module chunks = 0 1